"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tagColorMap = void 0;
exports.tagColorMap = {
    deal: 'bg-blue-4',
    ev: 'bg-grey-1',
    hold: 'bg-yellow-3',
    locked: 'bg-red-2',
    price: 'bg-green-2',
    reservable: 'bg-blue-2'
};
//# sourceMappingURL=constants.js.map